import { X, ExternalLink } from "lucide-react";
import { Button } from "./button";
import webyesPromoBanner from "../../assets/webyes-promo-banner.webp";
import { useBannerVisibility } from "@/hooks/useBannerVisibility";


const Banner = () => {
    const { isVisible, hide } = useBannerVisibility('webyes-promo');

    if (!isVisible) return null;
    return (

        <div className="cy:max-w-7xl  cy:mx-auto cy:px-4 cy:sm:px-6 cy:lg:px-8 cy:pt-8 ">
            {/* Background Grid Pattern */}

            <div className="cy:relative cy:bg-[#0B66E4] cy:rounded-xl cy:shadow-sm cy:flex cy:flex-col cy:lg:flex-row cy:items-stretch cy:min-h-[266px]"
                style={{
                    backgroundImage: `url(${webyesPromoBanner})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                }}
            >

                {/* Close Button */}
                <button
                    onClick={() => hide()}
                    className="cy:absolute cy:top-6 cy:right-4 cy:z-50 cy:p-1 cy:text-white/70 cy:hover:text-white cy:hover:bg-white/10 cy:rounded-full cy:transition-colors"
                    aria-label="Dismiss banner"
                >
                    <X size={24} />
                </button>

                {/* Left Content Area */}
                <div className="cy:w-[60%] cy:p-8 cy:flex cy:flex-col cy:relative cy:z-10">
                    <span className="cy:text-white cy:text-[12px] ">
                        Sponsored recommendation
                    </span>

                    <h2 className="cy:text-[18px] cy:font-bold cy:text-white!">
                        Beyond Widgets. Continue Your Accessibility Journey.
                    </h2>

                    <p className="cy:text-white cy:pb-4 cy:pr-10 cy:text-[14px] cy:leading-relaxed">
                        You have taken the first step towards accessibility. Now level up with deeper
                        audits, ongoing monitoring for accessibility issues, and detailed reporting with AI-
                        assisted solutions.<br />
                        Explore WebYes. One platform, better fixes.
                    </p>

                    <div className="cy:text-blue-500">
                        <Button
                            onClick={() => window.open('https://www.webyes.com/accessibility-checker/?utm_source=wordpress_plugin&utm_medium=banner&utm_campaign=accessyes&utm_content=plugin_banner', '_blank', 'noopener,noreferrer')}
                            className="cy:bg-white cy:text-[#0B66E4] cy:hover:bg-white/90 cy:font-semibold cy:px-6 cy:py-5 cy:rounded-md cy:flex cy:items-center cy:gap-2 cy:text-[16]"
                        >
                            Learn more about WebYes
                            <ExternalLink size={16} />
                        </Button>
                    </div>
                </div>

                {/* Right Graphic Area */}

            </div>
        </div>
    );
};

export default Banner;
